// Module
var code = `<template>
  <require from="./grid-filters-dialog.scss"></require>

  <mdc-dialog class="grid-filters-dialog">
    <mdc-dialog-title>Apply filters</mdc-dialog-title>
    <mdc-dialog-content>
      <div class="grid-filters-dialog__info">Apply filters to filter your table.</div>
      <template repeat.for="row of rows">
        <mdc-select if.bind="\$index" class="grid-filters-dialog__join" value.bind="row.condition.joinWithPrevious" hoist-to-body>
          <mdc-list>
            <mdc-list-item value="AND">And</mdc-list-item>
            <mdc-list-item value="OR">Or</mdc-list-item>
          </mdc-list>
        </mdc-select>
        <div class="grid-filters-dialog__row">
          <mdc-select class="grid-filters-dialog__column" label="Column" value.bind="row.condition.colId" hoist-to-body natural-width change.delegate="columnChanged(row, \$event.detail.value)">
            <mdc-list>
              <mdc-list-item repeat.for="col of model.columns" value.bind="col.colId">\${col.header}</mdc-list-item>
            </mdc-list>
          </mdc-select>
          <mdc-select label="Condition" value.bind="row.condition.operator" hoist-to-body natural-width change.delegate="operatorChanged(row, \$event.detail.value)">
            <mdc-list>
              <mdc-list-item repeat.for="op of row.operators" value.bind="op.value">\${op.label}</mdc-list-item>
            </mdc-list>
          </mdc-select>
          <mdc-datepicker if.bind="row.needsValue && row.isDate" value.two-way="row.condition.value | dateInput" format="dd.MM.yyyy" inputmask-format="dd.mm.yyyy" class="grid-filters-dialog__value"></mdc-datepicker>
          <div if.bind="row.needsValue && row.isSet" class="grid-filters-dialog__value">
            <mdc-text-field readonly="readonly" label="Values" value.bind="row.valuesText" ref="row.valuesAnchor" click.trigger="row.valuesMenu.toggle()" class="grid-filters-dialog__values-field">
              <mdc-icon mdc-text-field-icon trailing>arrow_drop_down</mdc-icon>
            </mdc-text-field>
            <mdc-menu view-model.ref="row.valuesMenu" anchor.bind="row.valuesAnchor" anchor-corner="BOTTOM_LEFT" hoist-to-body stay-open-on-selection>
              <mdc-list>
                <mdc-list-item repeat.for="opt of row.options">
                  <mdc-checkbox mdc-list-item-leading checked.bind="opt.selected" change.delegate="setValuesChanged(row)"></mdc-checkbox>
                  \${opt.label}
                </mdc-list-item>
              </mdc-list>
            </mdc-menu>
          </div>
          <mdc-text-field if.bind="row.needsValue && !row.isDate && !row.isSet" placeholder="Value" value.bind="row.condition.value" type.bind="row.valueType" class="grid-filters-dialog__value"></mdc-text-field>
          <button mdc-icon-button icon="delete" title="Remove condition" click.trigger="removeCondition(\$index)"></button>
        </div>
      </template>
      <button mdc-button outlined click.trigger="addCondition()">Add condition</button>
    </mdc-dialog-content>
    <mdc-dialog-actions>
      <button mdc-button outlined data-mdc-dialog-action="cancel">Cancel</button>
      <button mdc-button raised data-mdc-dialog-action="save">Save</button>
    </mdc-dialog-actions>
  </mdc-dialog>
</template>
`;
// Exports
export default code;